<template>
  <v-container class="ma-0 pa-0" fluid>
    <v-row dense align="center">
      <v-toolbar flat class="grey lighten-3">
        <v-toolbar-title>
          Promotions
        </v-toolbar-title>
        <template v-if="$auth.tenant === 'alliance-retail-group'">
          <v-col cols="auto" class="pr-4">
            <v-switch
              v-model="showGroupedPromos"
              color="action"
              dense
              :disabled="loading"
              hide-details>
              <template v-slot:label>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" :color="showGroupedPromos ? 'action' : undefined">
                      mdi-file-document-multiple-outline
                    </v-icon>
                  </template>
                  Group by Contract File
                </v-tooltip>
              </template>
            </v-switch>
          </v-col>
          <!-- <v-col cols="auto" class="mx-0 pr-4 d-flex align-center">
            <span class="mr-1 font-weight-medium">In-Flight:</span>
            <v-btn-toggle
              v-model="inFlightStatus"
              dense
              borderless
              background-color="grey lighten-3"
              class="mr-1"
              @change="getPromos"
            >
              <v-btn small value="show">Show</v-btn>
              <v-btn small value="hide">Hide</v-btn>
              <v-btn small value="all">All</v-btn>
            </v-btn-toggle>
          </v-col> -->
          <v-divider vertical inset></v-divider>
          <v-col cols="auto" class="pl-1">
            <PromoStatusFilter
              :value.sync="selectedStatuses"
              :loading="loading">
            </PromoStatusFilter>
          </v-col>
        </template>
        <template v-else>
          <v-col cols="auto" style="max-width: 300px">
            <v-select
              v-model="selectedStatuses"
              label="Status"
              :items="promo_statuses"
              item-text="name"
              item-value="id"
              :menu-props="{ offsetY: true }"
              multiple
              chips
              clearable
              :disabled="loading"
              @click:clear="selectedStatuses = []"
              background-color="#fff"
              item-color="action"
              dense
              hide-details
              outlined>
              <template v-slot:selection="{ item, index }">
                <v-chip small v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1"
                  class="grey--text text-caption"
                >
                  (+{{ selectedStatuses.length - 1}})
                </span>
              </template>
            </v-select>
          </v-col>
        </template>
        <v-col cols="3" class="ma-0 pa-0">
          <DateFilters v-model="dateParams" :disabled="loading" />
        </v-col>
        <v-col class="pl-1 pr-0">
          <SearchFilters v-model="searchParams" :disabled="loading" @search="getPromos" />
        </v-col>
        <v-col v-if="loading" cols="auto" class="pl-0">
          <v-btn
            height="40"
            depressed
            color="red"
            style="border-top-left-radius: 0px; border-bottom-left-radius:0px; border: 1px solid #9e9e9e; border-left: 0px;"
            @click.stop="cancel">
            <v-icon color="white">mdi-close-octagon-outline</v-icon>
          </v-btn>
        </v-col>
        <v-col v-else cols="auto" class="pl-0">
          <v-btn
            :loading="loading"
            :disabled="loading"
            height="40"
            depressed
            color="accent"
            style="border-top-left-radius: 0px; border-bottom-left-radius:0px; border: 1px solid #9e9e9e; border-left: 0px;"
            @click.stop="getPromos">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
        <v-btn
          v-if="tenant === 'alliance-retail-group' ? hasWriteAccess && !limitAccessByRelatedVendors : hasWriteAccess"
          @click.stop="showCategoryModal = true"
          elevation="0"
          :color="promoAddColor"
          class="pl-3 pr-2 white--text"
          height="40">
          Promo <v-icon class="ml-1">mdi-plus</v-icon>
        </v-btn>
        <template v-if="tenantUsesContractUpload && hasWriteAccess">
          <v-menu
            v-if="tenant === 'alliance-retail-group'"
            v-model="complexModal" 
            offset-y
            nudge-bottom="2px"
            :close-on-content-click="true">
            <template v-slot:activator="{}">
              <v-tooltip top nudge-bottom="15px">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="accent"
                    class="mx-2 white--text"
                    height="40"
                    small
                    fab
                    @click.stop="complexModal = true">
                    <v-icon>mdi-file-upload-outline</v-icon>
                  </v-btn>
                </template>
              Create promotions via contract file
            </v-tooltip>
            </template>
            <v-list color="info" dense>
              <v-list-item link dark ripple v-for="item in complexModalOptions" :key="item.name" @click="complexModalClicked(item)">
                {{item.name}}
              </v-list-item>
            </v-list>
          </v-menu>
          <v-tooltip v-else top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="accent"
                class="mx-2 white--text"
                height="40"
                small
                fab
                @click.stop="uploadModal = true">
                <v-icon>mdi-file-upload-outline</v-icon>
              </v-btn>
            </template>
            Create promotions via contract file
          </v-tooltip>
        </template>
      </v-toolbar>
    </v-row>
    <v-divider></v-divider>
    <v-data-table
      color="#fff"
      style="cursor:pointer"
      loading-text="Loading... Please wait"
      :headers="headers"
      :height="tableSize"
      :items-per-page="pageSize"
      :items.sync="promos"
      :loading="loading"
      hide-default-footer
      fixed-header
      :sort-by="tableSort.key"
      :sort-desc="tableSort.desc"
      :group-by="showGroupedPromos ? 'file_name' : undefined"
      dense
      @update:sort-by="setTableSortKey"
      @update:sort-desc="setTableSortDesc"
      @dblclick:row="viewPromo">

      <template v-slot:no-data>
          <v-card flat v-if="!loading">
            <v-card-text v-if="!activeSearch">
              No promos to show
            </v-card-text>
            <v-card-text v-else>
              No results found
            </v-card-text>
          </v-card>
        </template>

      <template v-slot:[`group.header`]="{ group, items, headers, toggle, isOpen }">
        <td :colspan="headers.length">
          <v-row @click="toggle" align="center">
            <v-btn class="my-auto ml-3" small icon :ref="group" :data-open="isOpen">
              <v-icon>{{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
            <v-col>
              <span v-if="!items[0].has_contract" class="font-italic font-weight-bold">
                No contract file
              </span>
              <span v-else class="font-weight-bold">
                <span v-if="items.some(promo => promo.product_line)">
                  {{ items.find(promo => promo.product_line !== null).product_line }}
                </span>
                <span v-else>{{ group.split('/').pop() }}</span>
              </span>
            </v-col>
            <v-col class="ml-auto" cols="2" v-if="items[0].has_contract">
              <span class="font-weight-bold">
                Upload date: {{ items[0].upload_date }}
              </span>
            </v-col>
            <v-col class="ml-auto" style="max-width: 8rem">
              <span class="font-weight-bold">
                Promos: {{  items.length  }}
              </span>
            </v-col>
          </v-row>
        </td>
      </template>

      <template v-slot:[`header.expanded`]>
        <v-btn @click="anyGroupsExpanded ? closeAll() : openAll()" :disabled="(promos.length === 0)" dark small icon>
          <v-icon v-if="anyGroupsExpanded">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <template v-slot:[`header.download`]="{ }">
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              dark
              small
              v-on="on">
              <v-icon class="mx-auto">
                mdi-download
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title class="grey--text text--darken-1">
                Select export type
              </v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click.stop="exportPromos('simple')"
              :disabled="exportLoading">
              <v-list-item-title>Simple</v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="exportPromos('detailed')"
              :disabled="exportLoading">
              <v-list-item-title>Detailed</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:[`item.in_flight`]="{ item }">
        <v-tooltip bottom v-if="item.in_flight" >
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="action" >
              mdi-airplane-takeoff
            </v-icon>
          </template>
          Promotion is In-Flight. Only administrators can make approved changes.
        </v-tooltip>
      </template>

      <template v-slot:[`item.lump_sum_allowance`]="{ item }">
        <span v-if="item.lump_sum_allowance">
          ${{ item.lump_sum_allowance.toFixed(2)}}
        </span>
      </template>

      <template v-slot:[`item.start_dt`]="{ item }">
        {{ $config.formatDate(item.start_dt) }}
      </template>

      <template v-slot:[`item.end_dt`]="{ item }">
        {{ $config.formatDate(item.end_dt) }}
      </template>

      <template v-slot:[`item.ad_date`]="{ item }">
        {{ $config.formatDate(item.ad_date) }}
      </template>

      <template v-slot:[`item.download`]="{ item }">
        <button icon @click.stop="download(item)">
          <v-icon class="mx-auto">
            mdi-download
          </v-icon>
        </button>
      </template>

      <template v-slot:[`item.download_contract`]="{ item }">
        <button v-if="item.has_contract"
          icon @click.stop="downloadContract(item)">
          <v-icon class="mx-auto">
            mdi-file-download
          </v-icon>
        </button>
      </template>

      <template v-slot:[`item.updated_on`]="{ item }">
        <div class="text-center">
          <v-menu
            open-on-hover
            top
            offset-y
            left>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="primary--text">
              {{ updatedOn(item) }}
              </span>
            </template>
              <v-card
              class="pa-2">
                <v-list-item-title>{{ updatedBy(item) }}</v-list-item-title>
              </v-card>
          </v-menu>
        </div>
      </template>

      <template v-slot:footer>
        <PagingFooter
          :pageSizes="pageSizes.concat(['pricechopper', 'alliance-retail-group'].includes(tenant) ? [500] : [])"
          :pageSize.sync="pageSize"
          :page="page"
          :disablePrevious="disablePrevious"
          :disableNext="disableNext"
          :showFirstPage="showFirstPage"
          @first="setFirstPage"
          @previous="previous"
          @next="next">
        </PagingFooter>
      </template>
    </v-data-table>
    <PromoCategoryModal
      v-if="showCategoryModal"
      v-model="showCategoryModal"
      :responsiblePartyId="responsibleParty.id"
      @cancel="showCategoryModal = false">
    </PromoCategoryModal>
    <ContractUploadModal
      v-if="uploadModal"
      v-model="uploadModal"
      :is_complex="is_complex"
      @closeUpload="closeUploadModal">
    </ContractUploadModal>
  </v-container>
</template>
<script>
// API
import Promos from '@/axios/promotion-endpoint'
import ContractUpload from '@/axios/contract-upload-endpoint'
// Mixins
import { fullWidthTable } from '@/mixins/table'
import { displayAlert } from '@/mixins/alert'
import { userAccess } from '@/mixins/user-access'
// Components
import SearchFilters from '@/components/SearchFilters.vue'
import DateFilters from '@/components/DateFilters.vue'
import PromoStatusFilter from '@/components/PromoStatusFilter.vue'
import PagingFooter from '@/components/shared/PagingFooter'
const PromoCategoryModal = () => import('@/components/PromoCategoryModal.vue')
const ContractUploadModal = () => import('@/components/contracts/ContractUploadModal.vue')
export default {
  name: 'Promos',
  data () {
    return {
      loading: true,
      exportLoading: false,
      uploadModal: false,
      tableSize: '',
      windowHeight: '',
      pageSize: (this.$auth.tenant === 'pricechopper') ? 500 : 200,
      pageSizes: [25, 50, 100, 200],
      page: 1,
      promos: [],
      dateParams: {},
      searchParams: {},
      selectedStatuses: [],
      selectedPromo: null,
      showCategoryModal: false,
      // AWG's dashboard defaults to the most recently started promos (the API orders their search by start_dt)
      tableSort: (this.$auth.tenant === 'awg') ? { key: 'start_dt', desc: true } : { key: null, desc: null },
      showGroupedPromos: false,
      inFlightStatus: 'all',
      is_complex: false,
      complexModal: false,
      complexModalOptions: [
        { name: 'Non-Complex', value: false },
        { name: 'Complex', value: true }
      ]
    }
  },
  components: { PromoCategoryModal, PagingFooter, SearchFilters, DateFilters, ContractUploadModal, PromoStatusFilter },
  mixins: [fullWidthTable, displayAlert, userAccess],
  watch: {
    promoFilters: {
      handler (newValue) {
        if (newValue) {
          if (this.page > 1) {
            this.page = 1
            if (this.$auth.tenant === 'alliance-retail-group') this.promos = []
          }
        }
      },
      deep: true
    },
    userRelatedPartyIds: {
      handler () {
        if (this.limitCategoriesByUserParties) {
          this.$store.dispatch('getUserCategories')
        }
      },
      deep: true
    },
    selectedStatuses: {
      handler (newValue) {
        if (newValue) {
          sessionStorage.setItem('promos_status_filter', JSON.stringify(newValue))
        } else {
          sessionStorage.removeItem('promos_status_filter')
        }
      },
      deep: true
    },
    tableSort: {
      handler(newValue) {
        if (!Object.values(newValue).every(value => !value)) {
          sessionStorage.setItem('table_sort', JSON.stringify(newValue))
        } else {
          sessionStorage.removeItem('table_sort')
        }
      },
      deep: true
    },
    page: {
      handler(newValue) {
        if (this.$auth.tenant === 'alliance-retail-group' && newValue) {
          sessionStorage.setItem('page', newValue)
        }
      },
    },
    pageSize: {
      handler(){
        this.getPromos()
      }
    },
    showGroupedPromos: {
      handler (newValue) {
        if (newValue) {
          sessionStorage.setItem('show_grouped_promos', JSON.stringify(newValue))
        } else {
          sessionStorage.removeItem('show_grouped_promos')
        }
      }
    },
    inFlightStatus: {
      handler (newValue) {
        if (newValue === 'all') {
          sessionStorage.removeItem('in_flight_status')
        } else {
          sessionStorage.setItem('in_flight_status', newValue)
        }
      }
    }
  },
  computed: {
    headers () {
      return [
        { text: '',  sortable: false, filterable: false, class: 'accent', show: !this.showExpandedHeader },
        { text: '', value: 'expanded', sortable: false, filterable: false, class: 'accent white--text', show: this.showExpandedHeader },
        { text: 'In Flight', sortable: true, filterable: true, value: 'in_flight', class: 'accent white--text', show: ['alliance-retail-group'].includes(this.tenant) },
        { text: 'Promotion Name', sortable: true, filterable: true, value: 'name', class: 'accent white--text' },
        { text: 'Promotion Category', sortable: true, filterable: true, value: 'promo_category_name', class: 'accent white--text' },
        { text: 'Promo Number', sortable: true, filterable: true, value: 'promo_number', class: 'accent white--text' },
        { text: 'Ad Fee', align: 'center', sortable: true, filterable: true, value: 'lump_sum_allowance', class: 'accent white--text', show: ['pricechopper'].includes(this.tenant) },
        { text: 'Ad/TPR Fee', align: 'center', sortable: true, filterable: true, value: 'lump_sum_allowance', class: 'accent white--text', width: '130', show: ['alliance-retail-group'].includes(this.tenant) },
        { text: 'Start Date', sortable: true, sort: (a, b) => Date.parse(a) - Date.parse(b), filterable: true, value: 'start_dt', class: 'accent white--text' }, 
        { text: 'End Date', sortable: true, sort: (a, b) => Date.parse(a) - Date.parse(b), filterable: false, value: 'end_dt', class: 'accent white--text' },
        { text: 'Ad Date', sortable: true, sort: (a, b) => Date.parse(a) - Date.parse(b), filterable: false, value: 'ad_date', class: 'accent white--text', show: this.tenant === 'alliance-retail-group' },
        { text: 'Last Updated', sortable: true, filterable: true, value: 'updated_on', class: 'accent white--text' },
        { text: 'Status', align: 'center', sortable: true, filterable: true, value: 'status', class: 'accent white--text' },
        { text: 'Download', sortable: false, filterable: false, value: 'download', class: 'accent white--text' },
        { text: 'Contract', sortable: false, filterable: false, value: 'download_contract', class: 'accent white--text', show: ['alliance-retail-group'].includes(this.tenant) }
      ].filter(header => header.show === undefined || header.show)
    },
    promoFilters () {
      return { ...this.searchParams, ...this.dateParams, status_ids: this.selectedStatuses }
    },
    activeSearch () {
      return Object.values(this.promoFilters).some(val => {
        return Array.isArray(val) ? (val.length > 0) : Boolean(val)
      })
    },
    activeFilter() {
      return Object.keys(sessionStorage).some(key => key?.includes('filter') && !!sessionStorage[key])
    },
    responsibleParties () {
      return this.$store.getters.responsible_parties
    },
    promo_statuses () {
      return this.$store.getters.promo_statuses.filter(status => status.constant !== 'CANCELLED')
    },
    responsibleParty () {
      return this.responsibleParties.find(party => party.tenant === this.tenant)
    },
    disablePrevious () {
      return (this.page - 1) === 0
    },
    disableNext () {
      return this.loading || (this.promos.length < this.pageSize)
    },
    showFirstPage () {
      return this.page > 1
    },
    offset () {
      return (this.page - 1) * this.pageSize
    },
    amap_excluded() {
      return this.excludeAMAPSelected || (['alliance-retail-group', 'pricechopper'].includes(this.tenant) && !this.activeSearch)
    },
    eba_excluded() {
      return this.excludeEBASelected || (['alliance-retail-group', 'pricechopper'].includes(this.tenant) && !this.activeSearch)
    },
    excludeAMAPSelected () {
      if (this.activeSearch && this.promoFilters?.promo_category_ids?.length > 0) {
        return this.promoFilters.promo_category_ids.includes('exclude-amap')
      }
      return false
    },
    excludeEBASelected () {
      if (this.activeSearch && this.promoFilters?.promo_category_ids?.length > 0) {
        return this.promoFilters.promo_category_ids.includes('exclude-eba')
      }
      return false
    },
    promoAddColor() {
      return this.tenant === 'alliance-retail-group' ? 'action' : 'primary'
    },
    anyGroupsExpanded () {
      if (this.promos.length > 0) {
        return Object.keys(this.$refs).some(k => {
          return (this.$refs[k] && this.$refs[k].$attrs['data-open'])
        })
      }
      return false
    },
    showExpandedHeader () {
      return (this.$auth.tenant === 'alliance-retail-group') && this.showGroupedPromos
    },
    currentDate() {
      return this.startOfDay(new Date())
    }
  },
  beforeCreate () {
    this.$store.dispatch('getPromoKeyValues')
    this.$store.dispatch('getPromoCategories')
  },
  async created () {
    this.resetAlert()
    this.nonTableHeight = 220.5
    if (this.$auth.tenant === 'alliance-retail-group' && sessionStorage.show_grouped_promos) {
      this.showGroupedPromos = JSON.parse(sessionStorage.show_grouped_promos)
    }
    if (sessionStorage.in_flight_status) {
      this.inFlightStatus = sessionStorage.in_flight_status
    }
    await this.$store.dispatch('getResponsibleParties')
    if (this.limitAccessByUserParties && this.userRelatedPartyIds.length === 0) {
      await this.$store.dispatch('getUserRelatedParties')
    }
    if (sessionStorage.promos_status_filter) {
      this.selectedStatuses = JSON.parse(sessionStorage.promos_status_filter)
    }
    if (this.$auth.tenant === 'alliance-retail-group' && sessionStorage.page) {
      this.page = Number(sessionStorage.page)
    }
    await this.getPromos()
    if (sessionStorage.table_sort) {
      this.tableSort = JSON.parse(sessionStorage.table_sort)
    }
    if (sessionStorage.scroll_position) {
      this.$nextTick(() => {
          const pos = Number(sessionStorage.getItem('scroll_position'))
          if (pos) this.setScrollPosition(pos)
        }
      )
    }
  },
  methods: {
    complexModalClicked(option) {
      this.is_complex = option.value
      this.uploadModal = true
    },
    closeAll () {
      Object.keys(this.$refs).forEach(k => {
        if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
          this.$refs[k].$el.click()
        }
      })
    },
    openAll () {
      Object.keys(this.$refs).forEach(k => {
        if (this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
          this.$refs[k].$el.click()
        }
      })
    },
    setTableSortKey(event) {
      this.tableSort.key = event ? event : null
    },
    setTableSortDesc(event) {
      this.tableSort.desc = event ? event : null
    },
    getPromoTypeName (item) {
      return item?.promo_category?.name || item.promotion_type?.name
    },
    setFirstPage () {
      this.page = 1
      this.getPromos()
    },
    async getPromos () {
      this.loading = true
      if (!this.responsibleParty || (this.limitAccessByRelatedSubvendors && this.relatedSubvendorPartyIds.length === 0)) {
        this.promos = []
        return this.loading = false
      }
      let promos = []
      try {
        let params = { offset: this.offset, limit: this.pageSize }
        if (this.amap_excluded) {
          params = { ...params, exclude_amaps: true }
        }
        if (this.eba_excluded) {
          params = { ...params, exclude_ebas: true }
        }
        if (this.$auth.tenant === 'alliance-retail-group' && !this.isAdmin) {
          params = { ...params, exclude_adman_sync: true }
        }
        const payload = this.buildPromoSearchPayload()
        const { data } = await Promos.search(payload, params)
        if (data?.length > 0) {
          promos = data
          if (this.$auth.tenant === 'alliance-retail-group') {
            promos = data.map(promo => {
              if (promo.product_line || (
                   promo.file_name 
                   && !['AMAP', 'Early Buy Allowance'].includes(promo.promo_category_name) 
                   && !['ipro_complex_contract@iprosystems.com', 'complex+contracts@iprosystems.com'].includes(promo.updated_by)
                )) {
                const splitParts = promo.file_name.split('/')
                const folderDate = [splitParts[4], splitParts[5], splitParts[3]].join('/')
                promo.upload_date = folderDate
                promo.has_contract = true
              } else {
                promo.file_name = 'z_no_contract'
                promo.upload_date = null
                promo.has_contract = false
              }
              promo.in_flight = this.checkInFlight(promo)
              return promo
            })
          }
        }
        this.promos = promos
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },
    checkInFlight (promo) {
      const startDate = this.startOfDay(promo.start_dt)
      const endDate = this.startOfDay(promo.end_dt)
      const isActive = this.currentDate >= startDate && this.currentDate <= endDate
      const isPast = this.currentDate > endDate
      const startDateDiff = (startDate - this.currentDate) / (1000 * 3600 * 24)
      const isNearTprEdlc = ['TPR', 'EDLC'].some(cat => promo.promo_category_name.includes(cat)) && promo.promo_category_name !== 'TPR Non Allowance' && startDateDiff <= 28
      const isNearPerishableAd = promo.billing_mode === 'Ad' && promo.perishable && startDateDiff <= 28
      const isNearNonPerishableAd = promo.billing_mode === 'Ad' && !promo.perishable && startDateDiff <= 56
      return isActive || isPast || isNearTprEdlc || isNearPerishableAd || isNearNonPerishableAd
    },
    async cancel() {
      this.loading = false
      await Promos.cancelSearch()
    },
    buildPromoSearchPayload() {
      let payload = {
        responsible_party_id: this.responsibleParty.id,
        vendor_coordinator_user: this.limitAccessByRelatedVendors,
        store_party_ids: [],
        ad_group_party_ids: []
      }
      if (this.limitAccessByRelatedVendors) {
        payload.vendor_party_ids = this.relatedVendorPartyIds
      }
      if (this.inFlightStatus) {
        const inFlight = (this.inFlightStatus === 'all') ? null : this.inFlightStatus
        payload.in_flight_status = inFlight
      }
      if (this.limitAccessByRelatedSubvendors) {
        payload.subvendor_party_ids = this.relatedSubvendorPartyIds
      }
      if (Object.entries(this.promoFilters).length > 0) {
        payload = { ...payload, ...this.promoFilters }
      }
      if (this.limitAccessByRelatedStores && (payload.store_party_ids.length === 0) && (payload.ad_group_party_ids.length === 0)) {
        payload.store_party_ids = [...this.relatedAdGroupsPartyIds, ...this.relatedDistCenterPartyIds, ...this.relatedStorePartyIds]
      }
      if (payload?.promo_category_ids?.includes('exclude-amap') || payload?.promo_category_ids?.includes('exclude-eba')) {
        payload.promo_category_ids = payload.promo_category_ids.filter(id => !['exclude-amap', 'exclude-eba'].includes(id))
        if (payload.promo_category_ids.length === 0) {
          delete payload.promo_category_ids
        }
      }
      return payload
    },
    viewPromo (event, {item}) {
      const promo = item
      const promo_category = promo.promo_category
      const pos = this.getScrollPosition()
      if (pos) sessionStorage.setItem('scroll_position', String(pos))
      this.$router.push({
        name: 'Promo',
        query: { id: promo.id },
        params: { promo_category }
      })
    },
    async download(promo) {
      try {
        const res =  await Promos.download_csv(promo.id)
        if (res.data){
          location.href = res.data;}
      } catch (err) {
        this.handleError(err)
      }
    },
    async downloadContract(promo) {
      try {
        const res =  await await ContractUpload.downloadContract({ promo_id: promo.id })
        if (res.data){
          location.href = res.data.url;
        }
      } catch (err) {
        this.handleError(err)
      }
    },
    async exportPromos(export_type) {
      this.exportLoading = true
      const params = this.buildPromoSearchPayload()
      if (export_type === 'simple') {
        params.simple_export = true
      }
      // Honor the AMAP/EBA toggles and adman-sync rule for every export type,
      // matching how getPromos() builds the search request.
      params.exclude_amaps = this.amap_excluded
      params.exclude_ebas = this.eba_excluded
      if (this.$auth.tenant === 'alliance-retail-group' && !this.isAdmin) {
        params.exclude_adman_sync = true
      }
      if (this.validateExport(params)) {
        try {
          const res =  await Promos.export(params)
          if (res?.data) {
            location.href = res.data
          }
        } catch (err) {
          this.handleError(err)
        } finally {
          this.exportLoading = false
      }
      }
    },
    validateExport(params) {
      // 10_713_600_000 is 124 days in milliseconds (~4 months)
      if (Object.hasOwn(params, 'start_dt') && Object.hasOwn(params, 'end_dt')) {
        if (Math.abs(Date.parse(params.end_dt) - Date.parse(params.start_dt)) <= 10713600000) {
          return true
        } else {
          this.emitAlert(true, 'warning', 'Multi-promo download is limited to 4 months')
        }
      } else {
        this.emitAlert(true, 'warning', 'Select a start and end date for multi-promo downloads')
      }
      return false
    },
    updatedBy(item){
      const updated = 'Updated By : ' + item.updated_by
      return updated
    },
    updatedOn(item){
      return this.$config.formatDate(item?.audit?.updated_on || item?.updated_on)
    },
    startOfDay (dateString) {
      const date = new Date(dateString)
      date.setHours(0, 0, 0, 0)
      return date
    },
    closeUploadModal(){
      this.uploadModal = false
    },
    previous () {
      this.page -= 1
      this.getPromos()
    },
    next () {
      this.page += 1
      this.getPromos()
    }
  }
}
</script>
<style>
.theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
  color: #fff !important;
}

#filters-container {
  display: grid;
  align-content: center;
  grid-auto-flow: column;
  justify-content: flex-start;
}
</style>